"use client";
import { jsx as c } from "react/jsx-runtime";
const t = () => /* @__PURE__ */ c(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    focusable: "false",
    height: "100%",
    width: "100%",
    children: /* @__PURE__ */ c("path", { d: "M3.333 5c.236 0 .434.08.594.24.16.16.24.357.24.593v10.834H12.5c.236 0 .434.08.594.24.16.159.24.357.24.593s-.08.434-.24.594a.806.806 0 0 1-.594.24H4.167c-.459 0-.851-.164-1.177-.49a1.605 1.605 0 0 1-.49-1.177V5.833c0-.236.08-.434.24-.593.16-.16.357-.24.593-.24ZM15 1.667c.458 0 .85.163 1.177.49.326.326.49.718.49 1.176v10c0 .459-.164.851-.49 1.177-.326.327-.719.49-1.177.49H7.5c-.458 0-.85-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.177v-10c0-.458.164-.85.49-1.177.326-.326.719-.49 1.177-.49H15Z" })
  }
);
export {
  t as IconCopy
};
